export default __webpack_public_path__ + "static/source-separation-systems-local-government-wmaa-8dc50e41c4476d60bd1414c7f19c4b45.png";